import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Link from "next/link";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import Grid from "@mui/material/Grid";
import Image from "next/image";
import P16 from "@/public/static/images/process/p-16.png";
import P17 from "@/public/static/images/process/p-17.png";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  height: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 0,
};

function PlantInfrastructure() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [image, setImage] = React.useState<any>(null);
  const [productName, setProductName] = React.useState<string | null>(null);

  return (
    <div className="row">
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P16);
              setProductName("圧力容器");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P16}
                  alt="圧力容器"
                  className="card-img"
                  
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  圧力容器
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">鋼、ステンレス</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      切断～溶接～塗装を社内加工外洋航路標識製作で裏付けられた溶接品質
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>

        <Grid item xs={12} sm={6} md={4} sx={{ mb: 2 }}>
          <Link
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(true);
              setImage(P17);
              setProductName("設備部品");
            }}
          >
            <Card className="card-product h-100">
              <div className="card-product_subpage">
                <div className="content-overlay"></div>
                <Image
                  src={P17}
                  alt="設備部品"
                  className="card-img"
                  
                  loading="lazy"
                />
                <div className="content-details fadeIn-top fadeIn-left">
                  <h1 className="mb-0">
                    <SearchIcon sx={{ fontSize: "40px" }} />
                  </h1>
                </div>
              </div>
              <CardContent className="product_inner-text">
                <Typography gutterBottom component="h5">
                  設備部品
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">材質</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">アルミ</p>
                  </Grid>
                  <Grid item xs={3}>
                    <p className="product-subject mb-0 fw-bold">特長</p>
                  </Grid>
                  <Grid item xs={9}>
                    <p className="product-des mb-0">
                      切断～溶接～アルマイト～塗装を社内加工アルミ溶接にも対応730
                      x 460 x 380mm 板厚 2mm
                    </p>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Link>
        </Grid>
      </Grid>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-inner">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
            className="close-btn"
          >
            <CloseIcon />
          </IconButton>
          <Image
            src={image}
            alt="Camera housing"
            className="card-img"
            
            loading="lazy"
          />
          <Typography
            id="modal-modal-title"
            className="modal-modal-title"
            variant="h6"
            component="h2"
          >
            {productName}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}

export default PlantInfrastructure;
